import React, { Fragment } from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import TermsAndConditionsText from '../TermsAndConditionsText';

import styles from './TotalCostSection.Styles';

const TotalCostSection = ({
  title,
  subTitle,
  renderAfterSubTitle,
  sections,
  primaryButtonTitle,
  onPrimaryButtonPress,
  termsAndConditionsProps,
  containerStyle,
  renderBreakDown,
}) => {
  const { note, ...termsAndConditionsPropsRest } = termsAndConditionsProps || {};
  const theme = useTheme();
  const _renderSection = (section, index) => {
    const { key, value, renderValue, renderSection } = section;
    if (_.isFunction(renderSection)) {
      return <Fragment key={index}>{renderSection()}</Fragment>;
    }
    return (
      <View key={index} style={styles.sectionRow}>
        <VFText style={styles.sectionKey} type={'primary'} i18nKey={key} />
        {renderValue ? (
          renderValue()
        ) : (
          <VFText style={styles.sectionValue} type={'primary'} i18nKey={value} />
        )}
      </View>
    );
  };
  const renderSections = () =>
    _.map(sections, (section, index) => (
      <View key={index} style={styles.sectionContainer(theme)}>
        {_.map(section, _renderSection)}
      </View>
    ));
  const renderTermsAndConditionsSection = () => (
    <View style={styles.tsSection(theme)}>
      <VFText type={'primary'} style={styles.termsText} i18nKey={note} />
      <TermsAndConditionsText {...termsAndConditionsPropsRest} />
    </View>
  );
  return (
    <View style={[styles.container(theme), containerStyle]}>
      <VFText type={'primary'} style={styles.totalCostText} i18nKey={title} />
      <VFText type={'primary'} style={styles.noteText} i18nKey={subTitle} />
      {_.isFunction(renderAfterSubTitle) && renderAfterSubTitle()}

      {renderSections()}
      {_.isFunction(renderBreakDown) && renderBreakDown()}
      {renderTermsAndConditionsSection()}
      <VFButton style={styles.button} title={primaryButtonTitle} onPress={onPrimaryButtonPress} />
    </View>
  );
};
TotalCostSection.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  renderAfterSubTitle: PropTypes.func,
  sections: PropTypes.array,
  primaryButtonTitle: PropTypes.string,
  onPrimaryButtonPress: PropTypes.func,
  termsAndConditionsProps: PropTypes.object,
  containerStyle: ViewPropTypes.style,
  renderBreakDown: PropTypes.func,
};
export default TotalCostSection;
